// extracted by mini-css-extract-plugin
module.exports = {"overflowedText":"OverflowedText_overflowedText__3Gy3r","overflowedTextWithBreakWords":"OverflowedText_overflowedTextWithBreakWords__S41lW"};